import AcademicFeesDashboard from "pages/Dashboard/FeesDashboard";
import React, { lazy, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

// Authentication
const Login = lazy(() => import("../pages/Authentication/Login"));
const Logout = lazy(() => import("../pages/Authentication/Logout"));
const Register = lazy(() => import("../pages/Authentication/Register"));
const ForgetPwd = lazy(() => import("../pages/Authentication/ForgetPassword"));
const Email = lazy(() => import("../pages/Authentication/Email"));
const AdminLogin = lazy(() => import("../pages/Authentication/AdminLogin"));
const ResetPassword = lazy(() => import("../pages/Authentication/ResetPassword"));
const ChangePassword = lazy(() => import("../pages/Authentication/ChangePassword"));
const UserProfile = lazy(() => import("../pages/Authentication/UserProfile"));
const Notification = lazy(() => import("../pages/Authentication/Notification"));
const Scheduler = lazy(() => import("../pages/Authentication/Scheduler"));
const BankAccount = lazy(() => import("../pages/Authentication/BankAccount"));
const ParentForgetPasswordPage = lazy(() => import("../pages/Authentication/ParentForgetPasswordPage"));
const ParentResetPassword = lazy(() => import("../pages/Authentication/ParentResetPassword"));

// Dashboard
const Dashboard = lazy(() => import("../pages/Dashboard"));
const ParentDashboardCard = lazy(() => import("../pages/Dashboard/ParentDashboard"));
const StudentSelection = lazy(() => import("../pages/Dashboard/StudentSelection"));

// Organization
const Centre = lazy(() => import("../pages/Organization/Centre"));
const AddCentre = lazy(() => import("../pages/Organization/Centre/add-centre"));
const EditCentre = lazy(() => import("../pages/Organization/Centre/edit-centre"));
const ProgramType = lazy(() => import("../pages/Organization/ProgramType"));
const AddProgramType = lazy(() => import("../pages/Organization/ProgramType/add-programtype"));
const EditProgramtype = lazy(() => import("../pages/Organization/ProgramType/edit-programtype"));
const Discount = lazy(() => import("../pages/Organization/Discount"));
const AddDiscount = lazy(() => import("../pages/Organization/Discount/add-discount"));
const EditDiscount = lazy(() => import("../pages/Organization/Discount/edit-discount"));
const Cluster = lazy(() => import("../pages/Organization/Cluster"));
const AddCluster = lazy(() => import("../pages/Organization/Cluster/add-cluster"));
const EditCluster = lazy(() => import("../pages/Organization/Cluster/edit-cluster"));
const Category = lazy(() => import("../pages/Organization/Category"));
const AddCategory = lazy(() => import("../pages/Organization/Category/add-category"));
const EditCatagory = lazy(() => import("../pages/Organization/Category/edit-category"));
const FeesStructure = lazy(() => import("../pages/Organization/FeesStructure"));
const AddFeeStructure = lazy(() => import("../pages/Organization/FeesStructure/add-feesstructure"));
const EditFeesstructure = lazy(() => import("../pages/Organization/FeesStructure/edit-feesstructure"));
const AcademicYear = lazy(() => import("../pages/Organization/AcademicYear"));
const EditAcademicyear = lazy(() => import("../pages/Organization/AcademicYear/edit-academicyear"));
const AddAcademicYear = lazy(() => import("../pages/Organization/AcademicYear/add-academicyear"));
const Payment = lazy(() => import("../pages/Organization/Payment"));
const AddPayment = lazy(() => import("../pages/Organization/Payment/add-payment"));
const EditPayment = lazy(() => import("../pages/Organization/Payment/edit-payment"));
const FeeType = lazy(() => import("../pages/Organization/FeeType"));
const AddFeeType = lazy(() => import("../pages/Organization/FeeType/add-feetype"));
const EditFeeType = lazy(() => import("../pages/Organization/FeeType/edit-feetype"));
const StudentFeeTypeAllocation = lazy(() => import("../pages/Organization/FeeType/student-feetype-allocation"));
const StudentFeeTypeUnAllocation = lazy(() => import("../pages/Organization/FeeType/student-feetype-unallocation"));
const StudentPaymentAllocation = lazy(() => import("../pages/Organization/Payment/student-payment-allocation"));
const StudentDiscountAllocation = lazy(() => import("../pages/Organization/Discount/student-discount-allocation"));
const StudentDiscountUnAllocation = lazy(() => import("../pages/Organization/Discount/student-discount-unallocation"));

// Users
const Users = lazy(() => import("../pages/Users"));
const AddUser = lazy(() => import("../pages/Users/add-user"));
const EditUser = lazy(() => import("../pages/Users/edit-user"));

// Student & Parent
const Student = lazy(() => import("../pages/Student"));
const AddStudent = lazy(() => import("../pages/Student/add-student"));
const EditStudent = lazy(() => import("../pages/Student/edit-student"));
const StudentDetail = lazy(() => import("../pages/Student/student-detail"));
const ParentList = lazy(() => import("../pages/Parent"));
const EditParent = lazy(() => import("../pages/Parent/edit-Parent"));
const AddParent = lazy(() => import("../pages/Parent/add-Parent"));

// Registration
const Registration = lazy(() => import("../pages/Registration"));
const AddRegistration = lazy(() => import("../pages/Registration/add-register"));
const EditRegistration = lazy(() => import("../pages/Registration/edit-Registration"));
const AddParentRegistration = lazy(() => import("../pages/Registration/add-parent-register"));
const ExistingStudentRegistration = lazy(() => import("../pages/Registration/existing-student-register"));
const ApplicationSuccess = lazy(() => import("../pages/Registration/application-success"));
const BookingObservation = lazy(() => import("../pages/Registration/book-observation"));
const ObservationSuccess = lazy(() => import("../pages/Registration/observation-success"));

// Observation
const Observation = lazy(() => import("../pages/Observation"));
const EditObservation = lazy(() => import("../pages/Observation/edit-observation"));

// Payment & Fees
const FeePaymentReceipt = lazy(() => import("../pages/Fees/FeePaymentReceipt"));
const RegistrationFee = lazy(() => import("../pages/Fees/RegistrationFee"));
const FeesPaidList = lazy(() => import("../pages/FeesPaid"));
const EditFeePaid = lazy(() => import("../pages/FeesPaid/edit-feePaid"));
const ViewRegistrationFee = lazy(() => import("../pages/FeesPaid/view-registration-fees"));
const PaymentSuccess = lazy(() => import("../pages/Payment/PaymentSuccess"));
const PaymentFailure = lazy(() => import("../pages/Payment/PaymentFailure"));
const RegisterFeePaymentFailure = lazy(() => import("../pages/Payment/RegisterFeePaymentFailure"));
const ApplyLateFees = lazy(() => import("../pages/ApplyFee/apply-Late-Fees"));
const PaymentStatus = lazy(() => import("../pages/PaymentStatus"));
const ViewPaymentStatus = lazy(() => import("../pages/PaymentStatus/view-payment"));

// Reports
const ManualPaymentList = lazy(() => import("../pages/Report/FeesPaid/AdminFeesPaid"));



const getUserRole = () => localStorage.getItem("userRole") || "Parent";
const role = getUserRole();

const authProtectedRoutes = [
  { path: `/dashboard`, component: <Dashboard /> },
  { path: `/fees-dashboard`, component: <AcademicFeesDashboard /> },
  { path: "/student", component: <Student /> },
  { path: "/add-student", component: <AddStudent /> },
  { path: "/edit-student", component: <EditStudent /> },
  { path: "/student-detail", component: <StudentDetail /> },
  { path: "/email", component: <Email /> },
  { path: "/notification", component: <Notification /> },
  { path: "/scheduler", component: <Scheduler /> },
  { path: "/centre", component: <Centre /> },
  { path: "/add-centre", component: <AddCentre /> },
  { path: "/edit-centre", component: <EditCentre /> },
  { path: "/program-type", component: <ProgramType /> },
  { path: "/add-program-type", component: <AddProgramType /> },
  { path: "/edit-program-type", component: <EditProgramtype /> },
  { path: "/cluster", component: <Cluster /> },
  { path: "/add-cluster", component: <AddCluster /> },
  { path: "/edit-cluster", component: <EditCluster /> },
  { path: "/discount", component: <Discount /> },
  { path: "/add-discount", component: <AddDiscount /> },
  { path: "/edit-discount", component: <EditDiscount /> },
  { path: "/category", component: <Category /> },
  { path: "/add-category", component: <AddCategory /> },
  { path: "/edit-category", component: <EditCatagory /> },
  { path: "/profile", component: <UserProfile /> },
  { path: "/change-password", component: <ChangePassword /> },
  { path: "/feestructure", component: <FeesStructure /> },
  { path: "/add-feestructure", component: <AddFeeStructure /> },
  { path: "/edit-feestructure", component: <EditFeesstructure /> },
  { path: "/academic-year", component: <AcademicYear /> },
  { path: "/edit-academicyear", component: <EditAcademicyear /> },
  { path: "/add-academicyear", component: <AddAcademicYear /> },
  { path: "/payment", component: <Payment /> },
  { path: "/add-payment", component: <AddPayment /> },
  { path: "/edit-payment", component: <EditPayment /> },
  {
    path: "/student-payment-allocation",
    component: <StudentPaymentAllocation />,
  },
  { path: "/users", component: <Users /> },
  { path: "/add-users", component: <AddUser /> },
  { path: "/edit-users", component: <EditUser /> },
  { path: "/parent-dashboard", component: <ParentDashboardCard /> },
  { path: "/fee-receipt", component: <FeePaymentReceipt /> },
  { path: "/parent-list", component: <ParentList /> },
  { path: "/edit-parent", component: <EditParent /> },
  { path: "/add-parent", component: <AddParent /> },
  {
    path: "/student-discount-allocation",
    component: <StudentDiscountAllocation />,
  },
    {
    path: "/student-discount-unallocation",
    component: <StudentDiscountUnAllocation />,
  },
  { path: "/fees-type", component: <FeeType /> },
  { path: "/add-feetype", component: <AddFeeType /> },
  {path: "/edit-feetype", component: <EditFeeType /> },
  {path: "/student-feetype-allocation", component: <StudentFeeTypeAllocation /> },
  {path: "/student-feetype-unallocation", component: <StudentFeeTypeUnAllocation /> },
  { path: "/bank-account-detail", component: <BankAccount /> },
  { path: "/fees-paid", component: <FeesPaidList /> },
  { path: "/edit-fees-paid", component: <EditFeePaid /> },
  { path: "/registration", component: <Registration /> },
  { path: "/edit-registration", component: < EditRegistration/> },
  { path: "/add-parent-registration", component: <AddParentRegistration /> },
  { path: "/observation", component: <Observation /> },
  { path: "/edit-observation", component: <EditObservation /> },
  { path: "/view-registration-fee", component: <ViewRegistrationFee /> },
  { path: "/apply-late-fee", component: <ApplyLateFees /> },
  { path: "/payment-status", component: <PaymentStatus /> },
  { path: "/view-payment-status", component: <ViewPaymentStatus /> },

  { path: "/", exact: true, component: <Navigate to={`/dashboard`} /> },
  { path: "/admin-manual-payment", component: <ManualPaymentList /> },
  

];

const ProtectedRoute = ({ component: Component }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return <Component />;
};

const publicRoutes = [
  { path: "/login", component: <ProtectedRoute component={Login} /> },
  { path: "/admin", component: <AdminLogin /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/student-selection", component: <StudentSelection /> },
  { path: "/application-form", component: <AddRegistration /> },
  { path: "/payment-success", component: <PaymentSuccess /> },
  { path: "/payment-failure", component: <PaymentFailure /> },
  { path: "/register-fee-payment-failure", component: <RegisterFeePaymentFailure /> },
  { path: "/book-observation", component: <BookingObservation /> },
  { path: "/observation-confirmation", component: <ObservationSuccess /> },
  {path: "/registration-fee", component: <RegistrationFee /> },
  {
    path: "/existing-parent-registration",
    component: <ExistingStudentRegistration />,
  },
  { path: "/application-success", component: <ApplicationSuccess /> },
  { path: "/parent-forgot-password", component: <ParentForgetPasswordPage /> },
  { path: "/parent-reset-password", component: <ParentResetPassword /> },
];

export { authProtectedRoutes, publicRoutes };
